import React from 'react';
import styled from 'styled-components';

const WidgetWrapper = styled.section`
	display: flex;
	flex-direction: column;
	width: 100vw;
	padding: 0 10vw;
	padding: 0 var(--side-margin);
	align-items: center;

	iframe {
		width: 769px;
		height: 230px;

		@media screen and (max-width: ${props => props.theme.tabletBreakPoint}) {
			width: 100%;
			height: 360px;
		}

		@media screen and (max-width: ${props => props.theme.mobileBreakPoint}) {
			width: 100%;
			height: 400px;
		}

		/* detecting IE */
		@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
			width: 956px;
		}
	}
`;

const SubscribeWidget = () => {
	return (
		<WidgetWrapper>
			<iframe
				title="subscribe-widget"
				frameBorder="0"
				scrolling="no"
				marginHeight="0"
				marginWidth="0"
				src="https://app.mailjet.com/widget/iframe/2wT1/49C"
			/>
		</WidgetWrapper>
	);
};

export default SubscribeWidget;



// WEBPACK FOOTER //
// ./src/components/SubscribeWidget.js